<div class="reconciliation-view-container">
  <h1>{{ 'SERVICE_PLAN_RECONCILIATION.TITLE' | translate }}</h1>

  <div class="reconciliation-view-toolbar">
    <div class="reconciliation-view-filter">
      <input
        id="incomplete-only-toggle"
        type="checkbox"
        #incompleteOnlyToggle
        [checked]="_incompleteOnly"
        (change)="onIncompleteOnlyChange(incompleteOnlyToggle.checked)"
      />
      <label for="incomplete-only-toggle">{{
        'SERVICE_PLAN_RECONCILIATION.INCOMPLETE_ONLY_LABEL' | translate
      }}</label>
    </div>

    <app-action-button
      kind="filled"
      color="primary"
      size="wider"
      type="button"
      [isDisabled]="_retryInProgress || _incompleteCount === 0"
      (onClick)="onRetryAllIncomplete()"
      >{{
        'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_BUTTON' | translate
      }}</app-action-button
    >
  </div>

  <div class="reconciliation-view-table-container">
    <app-table
      *ngIf="_dataLoaded"
      [columnDefinitions]="_tableColumnDefinitions"
      [columnsToDisplay]="_tableColumnsToDisplay"
      [dataSource]="_tableData"
      [noDataText]="'SERVICE_PLAN_RECONCILIATION.NO_DATA' | translate"
      kind="standard"
      pageSize="20"
      (onLinkButtonClick)="onRetryClick($event)"
    />
  </div>
</div>
